import { render, staticRenderFns } from "./DeleteBrandTutorialVideoPopup.vue?vue&type=template&id=6bfe6b7f&scoped=true&"
import script from "./DeleteBrandTutorialVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteBrandTutorialVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteBrandTutorialVideoPopup.vue?vue&type=style&index=0&id=6bfe6b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe6b7f",
  null
  
)

export default component.exports